import React, { useContext } from "react"
import moment from "moment-timezone"
import UserImage from "./UserImage"
import PhoneNumber from "../../PhoneNumber"
import { SpaceProfileContext } from "../context"
import MarketingConsentCheckbox from "../../MarketingConsentCheckbox"

export default ({
  space,
  name,
  email,
  message,
  setName,
  setEmail,
  setMessage,
  phone,
  setPhone,
  inline = false,
  formOnly = false,
  messageRequired = false,
  marketingEmails,
  setMarketingEmails,
}) => {
  const {
    commonData: { contextDate, contextTime },
  } = useContext(SpaceProfileContext)

  return (
    <div className={"reservation-form"}>
      <form className="schedule-call">
        <div className="row">
          {!formOnly && (
            <div className="col-12">
              {!inline && <UserImage space={space} />}
              <h5>Confirm call</h5>
              <p className="title-sub">
                {contextTime},{" "}
                {moment(contextDate).format("dddd, MMMM DD, YYYY")}
              </p>
            </div>
          )}
          <div className={inline ? "col-sm-12" : "col-lg-6"}>
            <div className="form-group">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                name={"name"}
                placeholder={"Full name *"}
                className="form-control"
              />
            </div>
          </div>
          <div className={inline ? "col-sm-12" : "col-lg-6"}>
            <div className="form-group">
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                name={"email"}
                placeholder={"Work Email *"}
                className="form-control"
              />
            </div>
          </div>
          <div className={inline ? "col-sm-12" : "col-lg-6"}>
            <div className="form-group">
              <PhoneNumber
                setPhone={setPhone}
                value={phone}
                placeholder={"Phone Number *"}
              />
            </div>
          </div>

          <div className={inline ? "col-sm-12" : "col-lg-6"}>
            <div className="form-group">
              <input
                type={"text"}
                name="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder={
                  messageRequired ? `Message *` : "Additional notes (Optional)"
                }
                className="form-control fixed-height d-none d-lg-block"
              />
              <textarea
                className="form-control d-lg-none"
                name={"message"}
                onChange={(e) => setMessage(e.target.value)}
                value={message}
                placeholder={
                  messageRequired ? `Message *` : "Additional notes (Optional)"
                }
              />
            </div>
          </div>

          <MarketingConsentCheckbox
            checked={marketingEmails}
            setChecked={setMarketingEmails}
          />
        </div>
      </form>
    </div>
  )
}
